import z from "zod";
import { looseUuid } from "@thalamos/common";
export const CreateSoadRequestSchema = z.object({
    email: z.string().trim().toLowerCase().pipe(z.email("Invalid email address")),
    name: z.string().trim().min(1, "Name is required"),
    soadTeamId: looseUuid(),
    soadOrganisationId: looseUuid(),
    cqcOrganisationId: looseUuid(),
});
//# sourceMappingURL=soadRequests.js.map